import { useState, useEffect } from "react";

const DEFAULT_MOBILE_BREAKPOINT = 768;
const DEFAULT_TABLET_BREAKPOINT = 1024;

const getWindowWidth = () => {
  if (typeof window === "undefined") {
    return 0;
  }
  return window.innerWidth;
};

export const useBreakpoint = () => {
  const [width, setWidth] = useState(getWindowWidth());

  useEffect(() => {
    const handleResize = () => {
      setWidth(getWindowWidth());
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = width <= DEFAULT_MOBILE_BREAKPOINT;
  const isTablet =
    width > DEFAULT_MOBILE_BREAKPOINT && width <= DEFAULT_TABLET_BREAKPOINT;
  const isDesktop = width > DEFAULT_TABLET_BREAKPOINT;

  return {
    width,
    isMobile,
    isTablet,
    isDesktop,
  };
};

